import { Chat, PinnedChat } from '@src/api/shared/community/chatApiClient';
import IconPin from '@src/assets/images/common/icon/channel/chat-menu-pin.svg';
import ChatAvatar from '@src/features/shared/community/components/chat/chatList/ChatAvatar';
import ChatDisplayName from '@src/features/shared/community/components/chat/chatList/ChatDisplayName';
import dayjs from 'dayjs';
import React from 'react';

type ChatItemHeaderProps = {
  channelCode: string;
  chat: Chat | PinnedChat;
  channelVisibility?: number;
  pinnedChat?: PinnedChat;
  isLoggedIn?: boolean;
};

export const TOOLTIP_DISPLAY_TIME = 3000;

const ChatItemHeader: React.FC<ChatItemHeaderProps> = ({
  channelCode,
  chat,
  channelVisibility,
  pinnedChat,
  isLoggedIn,
}) => {
  return (
    <div className='flex items-center gap-3'>
      <ChatAvatar
        channelCode={channelCode}
        chat={chat}
        channelVisibility={channelVisibility}
        isLoggedIn={isLoggedIn}
      />
      <div className='flex items-center gap-1 truncate'>
        {pinnedChat && pinnedChat.id === chat.id ? (
          <img
            className='size-[20px] flex-[0_0_auto]'
            src={IconPin}
            width='20'
            height='20'
            alt=''
          />
        ) : null}
        <ChatDisplayName
          channelCode={channelCode}
          chat={chat}
          channelVisibility={channelVisibility}
          isLoggedIn={isLoggedIn}
        />
      </div>
      <div className='flex gap-[4px]'>
        <span className='text-[10px]'>{dayjs(chat.created_at).format('HH:mm')}</span>
      </div>
    </div>
  );
};

export default ChatItemHeader;
